import React, { useState } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import { update } from "./services/upload-files.service";

const EditUserDetails = ({ activeTab, handleInputChange, formData, setLoading, setFormData, userdetails }) => {
    const [validationErrors, setValidationErrors] = useState({});
    

    

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                setLoading(true);
                let fData = new FormData();

                fData.append("user", JSON.stringify(formData.user));
                fData.append("personal_info", JSON.stringify(formData.personal_info));
                fData.append("company_info", JSON.stringify(formData.company_info));

                const res = await update(fData, `users/profile/${userdetails.id}`);
                if (res && res.success) {
                    setValidationErrors({});
                    setFormData(res);
                
                    console.log('plz enter valid info');
                } else {
                    setValidationErrors({ general: "Please Enter Valid Information" });
                }
            } catch (error) {
                setValidationErrors({ general: "An Error Occurred. Please Try Again Later." });
            } finally {
                setLoading(false);
            }
        }
    };

    const validateFormFields = (formData) => {
        const errors = {};
        const isAlphabetic = (str) => /^[a-zA-Z\s]+$/.test(str);
        const isNumeric = (str) => /^\d+$/.test(str);
        const isLength = (str, length) => str.length === length;

        if (!formData.user || !formData.user.firstname?.trim()) {
            errors.user = { ...errors.user, firstname: "Please Enter First Name" };
        } else if (!isAlphabetic(formData.user.firstname)) {
            errors.user = { ...errors.user, firstname: "First Name Should Contain Only Letters" };
        }

        if (!formData.user || !formData.user.lastname?.trim()) {
            errors.user = { ...errors.user, lastname: "Please Enter Last Name" };
        } else if (!isAlphabetic(formData.user.lastname)) {
            errors.user = { ...errors.user, lastname: "Last Name Should Contain Only Letters" };
        }

        if (!formData.user || !formData.user.contact?.trim()) {
            errors.user = { ...errors.user, contact: "Please Enter a Contact Number" };
        } else if (!isNumeric(formData.user.contact) || !isLength(formData.user.contact, 10)) {
            errors.user = { ...errors.user, contact: "Please Enter a Valid Contact Number" };
        }

        return errors;
    };

    return (
        <>
            <div className={`tab-pane fade ${activeTab === "user-details" ? "show active" : ""}`}>
                <div className="row">
                    <div className="col-4">
                        <div className="editprofile">
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="fname">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="user__firstname"
                                        value={formData.user?.firstname || ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.user?.firstname && (
                                        <div className="error login-error">{validationErrors.user.firstname}</div>
                                    )}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="lname">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="user__lastname"
                                        value={formData.user?.lastname || ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.user?.lastname && (
                                        <div className="error login-error">{validationErrors.user.lastname}</div>
                                    )}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="contact">
                                    <Form.Label>Contact no</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="user__contact"
                                        value={formData.user?.contact || ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.user?.contact && (
                                        <div className="error login-error">{validationErrors.user.contact}</div>
                                    )}
                                </Form.Group>
                                {validationErrors.general && (
                                    <div className="error login-error">{validationErrors.general}</div>
                                )}
                                <button className="btn btn-primary btn-add mb-3" type="submit">
                                    Save
                                </button>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

        
            
        </>
    );
};

export default EditUserDetails;
